define((require) => {
    "use strict";

    const Action            = require("editor/util/Action");
    const EditorEvents      = require("shared/services/EditorEvents");
    const Permissions       = require("shared/security/Permissions");
    const LoggedIn          = require("shared/security/LoggedIn");

    /**
     * Action that duplicates an experience.
     *
     * @class DuplicateExperienceAction
     */
    return Action.extend({

        /**
         * Constructor.
         *
         * @param  {ExperienceModel} model   The experience to duplicate.
         * @param  {Object} options Additional options:
         *
         * @cfg {String}         postfix Optional name postfix.
         * @cfg {ProjectContext} projectContext Optional <tt>ProjectContext</tt>.
         */
        constructor: function(model, options) {
            this.__super();

            this._model = model;
            this._options = options || {};
        },

        executable: function() {
            return Permissions.Privileges.CREATE.can();
        },

        _performExecution: function(eventProperties, eventTrigger = EditorEvents.constants.DUPLICATE_EXPERIENCE) {
            const experienceModel = this._model;
            const projectContext = this._options.projectContext;
            const postfix = this._options.postfix ? " (" + this._options.postfix + ")" : "";

            // Make sure we fetch all before cloning...
            return experienceModel
                .fetchAll()
                .then(() => {
                    const clone = experienceModel.clone({duplicate: true, duplicateExperienceWithUUID: true});

                    clone.set("name", experienceModel.get("name") + postfix);
                    clone.set("companyId", LoggedIn.principal().get("companyId"));

                    return clone.save().then(() => {
                        return clone;
                    });
                })
                .then((clone) => {
                    // Attach the cloned experience to the project, if any...
                    if (projectContext) {
                        return projectContext.attach(clone).then(() => {
                            return clone;
                        });
                    }

                    // Hacky: during grouplicate we get here with an experience, fix it up
                    // this avoids a Missing TriggerOrigin property precondition failure later
                    // TODO: is any of this used/needed anymore?
                    if (eventProperties && eventProperties.triggerOrigin) {
                        eventProperties = {
                            triggerOrigin: eventProperties.triggerOrigin
                        };
                    }  else if (eventProperties && eventProperties.get("height")) {
                        eventProperties = {
                            experienceId: eventProperties.get("id"),
                            experienceVersion: eventProperties.get("version"),
                            experiencePushedVersion: eventProperties.get("pushedVersion"),
                            triggerOrigin: "ExperienceExport"
                        };
                        eventTrigger = EditorEvents.constants.EXPORT_EXPORT;
                    } else {
                        eventProperties = eventProperties || {
                            projectId: projectContext && projectContext.project.get("id"),
                            experienceId: experienceModel.get("id"),
                            experienceVersion: experienceModel.get("version"),
                            experiencePushedVersion: experienceModel.get("pushedVersion"),
                            triggerOrigin: "DuplicateExperienceButton"
                        };
                    }


                    EditorEvents.trigger(eventTrigger, eventProperties);

                    return clone;
                });
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/actions/DuplicateExperienceAction.js